import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { FullProductApiModel } from "lib/@types/service/product/api/product.api.model";

import { getFeatureLabels } from "../../helpers";

type FeatureLabelsProps = {
    product: FullProductApiModel;
};

const FeatureLabels = ({ product }: FeatureLabelsProps) => {
    const { t } = useGranite();
    const featureLabels = getFeatureLabels(product);

    return (
        <section className="feature-list-component feature-labels__container mb-3">
            {featureLabels.map((label, index) => (
                <img
                    key={`label-${index}`}
                    className="feature-labels__image"
                    src={label.imageUrl}
                    alt={t(label.altText)}
                />
            ))}
        </section>
    );
};

export { FeatureLabels };
